import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/all`,
        isArray: true
    },
    getAllSummaries: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/all/summaries`,
        isArray: true
    },
    getVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/:id`
    },
    updateVendorPersonalInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/vendors/:id/personalInfo`
    },
    updateVendorContactInfo: {
        method: 'PUT',
        url: `${BASE_PATH_API}/vendors/:id/contactInfo`
    },
    updateVendorTaxInfo: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendors/:id/taxInfo`
    },
    setVendorStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/vendors/:id/status`
    },
    deleteVendor: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/vendors/:id`
    },
    lookupVendors: {
        method: 'GET',
        url: `${BASE_PATH_API}/lookup/vendors?isActive?onlySetupForAch?payeeUserId`
    },
    getVendorCategories: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/categories`,
        isArray: true
    },
    getVendorsPaging: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors`,
        params: {
            '$count': true
        }
    },
    createVendor: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendors`
    },
    getVendorInfoDetailed: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/vendors/:id`
    },
    getVendorTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/:vendorId/transactions`,
        isArray: true
    },
    getEftInformationForVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/:vendorId/eft`
    },
    createVendorRefund: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendorRefunds`
    },
    updateVendorRefund: {
        method: 'PUT',
        url: `${BASE_PATH_API}/vendorRefunds/:id`
    },
    getVendorRefund: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendorRefunds/:id`
    },
    deleteVendorRefund: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/vendorRefunds/:id`
    },
    updateVendorInsurance: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendor/:vendorId/insurance`
    },
    deleteVendorInsurance: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/vendor/:vendorId/insurance`
    },
    getVendorInsurance: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendor/:vendorId/insurance`
    },
    createVendorCredit: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendorCredits`
    },
    getVendorCredit: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendorCredits/:journalId`
    },
    updateVendorCredit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/vendorCredits/:journalId`
    },
    deleteVendorCredit: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/vendorCredits/:journalId`
    },
    getVendorLedgers: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/ledgers`,
    },
    getVendorsWebsiteAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/websiteAccounts`,
        params: {
            '$count': true
        }
    },
    createVendorWebsiteAccounts: {
        method: 'POST',
        url: `${BASE_PATH_API}/vendors/websiteAccounts`
    },
    isEfilingEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/isEfilingEnabled`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/vendors/defaultManagementFeePolicy`
    }
};

export function VendorsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getVendorsExportUrl = function getVendorsExportUrl(params) {
        return `${BASE_PATH_API}/vendors/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
VendorsApi.$inject = [
    '$httpParamSerializer'
];
